import { render, staticRenderFns } from "./ResetPass.vue?vue&type=template&id=782f99a1"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports